import { createSelector } from '@reduxjs/toolkit'
import { ClientsStoreModel, RootStoreModel } from '../store.model'

const profileState = (store: RootStoreModel) => store.profile

export const selectCompanies = createSelector(profileState, profileState => profileState.companies)

export const selectCompanyCommodities = createSelector(
  profileState,
  profileState => profileState.activeCompany?.commodities
)

export const selectActiveCompany = createSelector(
  profileState,
  profileState => profileState.activeCompany
)

export const selectBalanceZones = createSelector(
  profileState,
  profileState => profileState.balanceZones
)

export const selectActiveBalanceZone = createSelector(
  profileState,
  profileState => profileState.activeBalanceZone
)
